"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeleteTimeOffCategoryMutation = void 0;
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const ui_1 = require("@app/component/ui");
const request_1 = require("@app/request");
const store_1 = require("@app/store");
const maybe_unwrap_1 = require("@app/util/apollo/maybe-unwrap");
const error_handler_1 = require("@app/util/error-handler");
const useWorkspace_1 = require("@app/util/hooks/useWorkspace");
const request_timeoff_category_delete_1 = require("@app/request/timeoff-category/request-timeoff-category-delete");
const util_1 = require("@app/util");
const load_workspace_detail_1 = __importDefault(require("./load-workspace-detail"));
const set_modal_1 = __importDefault(require("./set-modal"));
function useDeleteTimeOffCategoryMutation() {
    const workspace = (0, useWorkspace_1.useWorkspace)();
    const workspaceId = workspace?.id;
    const auth = (0, store_1.useRootSelector)((state) => state.auth);
    const dispatch = (0, store_1.useRootDispatch)();
    return async function handleDelete(categoriesToDeleteIds) {
        // check if the WS has some unav instances with this category
        let existingTimeOffs = [];
        if ((0, util_1.isUndefined)(workspaceId)) {
            throw new Error('useDeleteTimeOffCategoryMutation: workspace.id cannot be undefined');
        }
        for (const categoryId of categoriesToDeleteIds) {
            const next = await (0, request_1.requestTimeOffsWorkspace)({
                workspace: workspaceId,
                categoryIds: [categoryId],
                period: {
                    start: (0, moment_1.default)().add(-2, 'years'),
                    end: (0, moment_1.default)().add(2, 'years'),
                },
            }, auth);
            existingTimeOffs = [...existingTimeOffs, ...(next ?? [])];
        }
        const deleteInstances = async () => {
            const ids = existingTimeOffs.map((r) => r.id);
            // delete timeOff instances with this category
            if (ids?.length) {
                await (0, request_1.requestTimeOffDeleteMulti)({
                    workspace: workspaceId,
                    data: ids.map((i) => {
                        return { id: i };
                    }),
                }, auth);
            }
        };
        const deleteCategories = async () => {
            // const updatedCategoriesList = workspace?.unavailabilityCategories?.map(
            //   (category) => {
            //     if (categoriesToDeleteIds.includes(category.id)) {
            //       return { ...category, archived: true }
            //     } else {
            //       return category
            //     }
            //   }
            // )
            try {
                for (const id of categoriesToDeleteIds) {
                    await (0, request_timeoff_category_delete_1.requestTimeOffCategoryDelete)({
                        workspace: workspaceId,
                        id,
                    });
                }
            }
            catch (e) { }
            // await requestWorkspaceUpdate(
            //   {
            //     id: workspaceId,
            //     data: {
            //       unavailabilityCategories:
            //         getSanitizedCategoriesList(updatedCategoriesList),
            //     },
            //   },
            //   auth
            // )
            await dispatch((0, load_workspace_detail_1.default)(workspaceId));
        };
        if (existingTimeOffs.length === 0) {
            try {
                await deleteCategories();
            }
            catch (error) {
                (0, error_handler_1.processErrors)([], (0, maybe_unwrap_1.unwrapMaybe)((0, util_1.t)('ERR_MESSAGE.error')));
                console.log('Delete categories failed', error);
            }
            return;
        }
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        const setModalAction = (0, set_modal_1.default)('confirm', {
            title: (0, util_1.t)('WS_SETTINGS_CONFIRM_DELETE_CAT'),
            subtitle: (0, util_1.t)('WS_SETTINGS_CONFIRM_DELETE_CAT_SUBTITLE'),
            text: (react_1.default.createElement(ui_1.Spacing, { type: ui_1.Spacing.TYPES.VERTICAL, size: ui_1.Spacing.SIZES.SIZE_16 }, (0, util_1.t)('WS_SETTINGS_CONFIRM_DELETE_CAT_TXT_X', {
                x: existingTimeOffs.filter((un) => un.period && (0, moment_1.default)(un.period.start).isBefore((0, moment_1.default)())).length,
                y: existingTimeOffs.filter((un) => un.period && (0, moment_1.default)(un.period.start).isSameOrAfter((0, moment_1.default)())).length,
            }))),
            confirmLabel: (0, util_1.t)('DELETE'),
            onConfirm: async () => {
                try {
                    await deleteInstances();
                    await deleteCategories();
                }
                catch (error) {
                    (0, error_handler_1.processErrors)([], (0, maybe_unwrap_1.unwrapMaybe)((0, util_1.t)('ERR_MESSAGE.error')));
                    console.log('Delete instances or categories failed', error);
                }
            },
            cancelLabel: (0, util_1.t)('CANCEL'),
            onCancel: () => { },
            overSidebar: true,
            buttonColor: 'red',
        });
        // when used in batch actions, this helps to close batch actions modal
        // before opening confirmation modal
        setTimeout(() => {
            void dispatch(setModalAction);
        }, 0);
        return null;
    };
}
exports.useDeleteTimeOffCategoryMutation = useDeleteTimeOffCategoryMutation;
